import { ContentViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockContent: ContentViewModel = {
  ingressCostAndInvoice: {
    body: `<h2>M&aring;nadsfaktura baserad p&aring; m&aring;natlig rapportering</h2>
  <p>M&aring;nadsfakturan avser Avtalspension SAF-LO och &ouml;vriga f&ouml;rs&auml;kringar f&ouml;r arbetare. Varannan m&aring;nadsfaktura inneh&aring;ller &auml;ven kostnader f&ouml;r Deltidspensionsavs&auml;ttning, Extra pensionsavs&auml;ttning och f&ouml;rbundsavgifter, om detta ing&aring;r i f&ouml;retagets kollektivavtal.</p>`,
  },
  ingressEmployments: {
    body: `<p>Alla anst&auml;llda som omfattas av Avtalspension SAF-LO (oavsett &aring;lder) ska registreras och tilldelas en uppm&auml;rkning. Det &auml;r i regel personalkategorin &ldquo;Arbetare&rdquo;. Registrera inte n&aring;gra andra anst&auml;llda. F&ouml;r att du ska kunna registrera en anst&auml;lld kr&auml;vs svenskt personnummer eller samordningsnummer (ans&ouml;kan g&ouml;rs hos Skatteverket).</p>
  <p>Registrering och uppm&auml;rkning av anst&auml;llda kan g&ouml;ras p&aring; tre olika s&auml;tt:</p>
  <ul>
  <li>Manuell inmatning av individuppgifter och uppm&auml;rkning i den h&auml;r tj&auml;nsten.</li>
  <li>Med fil som skapas utifr&aring;n <a href="https://www.fora.se/uppmarkning-mall" target="_blank" rel="noopener noreferrer">Foras Excelmall</a>&nbsp;f&ouml;r individuppgifter och uppm&auml;rkning.</li>
  <li>Med fil som du exporterat fr&aring;n l&ouml;nesystem, inneh&aring;llande individuppgifter och uppm&auml;rkningar.</li>
  </ul>`,
  },
  ingressEmploymentsNoEmployments: { body: '<p>Mock content ingress</p>' },
  ingressMarkups: {
    body: `<h2>Uppm&auml;rkning av anst&auml;llda</h2>
  <p>Uppm&auml;rkning &auml;r grunden f&ouml;r att de anst&auml;llda ska omfattas av r&auml;tt f&ouml;rs&auml;kringar och f&aring; r&auml;tt premier inbetalda till sin tj&auml;nstepension. Det &auml;r bara anst&auml;llda som omfattas av Avtalspension SAF-LO (vanligen personalkategorin &rdquo;Arbetare&rdquo;) som ska tilldelas en uppm&auml;rkning.</p>
  <p>H&auml;r finns de uppm&auml;rkningar som &auml;r m&ouml;jliga att v&auml;lja p&aring; f&ouml;r ert f&ouml;retag. Har f&ouml;retaget flera uppm&auml;rkningar att v&auml;lja bland, &auml;r det vilket kollektivavtal den anst&auml;llda g&aring;r under som styr uppm&auml;rkningen.</p>
  <p>G&ouml;r du uppm&auml;rkningen via fil (fr&aring;n l&ouml;nesystem eller Excel) anv&auml;nder du kopiera-funktionen f&ouml;r att l&auml;gga in r&auml;tt kod i l&ouml;nesystemet/Excelfilen. Matar du in de anst&auml;llda manuellt i e-tj&auml;nsten Administrera arbetare, beh&ouml;ver du inte h&auml;mta koden h&auml;r.</p>`,
  },
  ingressPayrolls: {
    body: `<p>L&ouml;n ska rapporteras f&ouml;r alla anst&auml;llda som omfattas av Avtalspension SAF-LO. Det &auml;r i regel personalkategorin &ldquo;Arbetare&rdquo;. Rapporteringen ska vara gjord senast sista dagen i den m&aring;nad som kommer efter utbetalningsm&aring;naden.</p>
  <ul>
  <li>Alla anst&auml;llda som omfattas av Avtalspension SAF-LO, oavsett &aring;lder och anst&auml;llningsform, ska tas med.</li>
  <li>Anst&auml;llda m&aring;ste ha svenskt personnummer eller samordningsnummer.</li>
  <li>Alla anst&auml;llda ska ha tilldelats en uppm&auml;rkning.</li>
  </ul>`,
  },
  ingressPayrollsNoReports: { body: '<p>Mock content ingress</p>' },
  ingressFileDashboardNoReports: {
    body: `<h3>S&aring; v&auml;ljer du r&auml;tt e-tj&auml;nst - EPI</h3>
<h5>Jag har en komplett fil fr&aring;n l&ouml;nesystemet, med uppm&auml;rkningar och l&ouml;neuppgifter</h5>
<p aria-hidden="false">Ladda upp din fil under Filuppladdning p&aring; den h&auml;r sidan.</p>
<h5>Jag vill mata in alla uppgifter manuellt</h5>
<p aria-hidden="false">Registrera och m&auml;rk upp de anst&auml;llda i e-tj&auml;nsten Administrera arbetare. Rapportera d&auml;refter l&ouml;nerna i e-tj&auml;nsten Manuell inmatning av l&ouml;ner.</p>`,
  },
  faqListEmployments: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEmploymentsNoEmployments: [
    {
      question: 'Inga anställningar?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmployment: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmploymentReceiptStep: [
    {
      question: 'Receipt step! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListUpdateEmployment: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListUpdateEmploymentReceiptStep: [
    {
      question: 'Receipt step! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListCostAndInvoice: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListMarkups: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListPayrolls: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListPayrollsNoReports: [
    {
      question: 'First report',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListReportPayroll: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListReportPayrollConfirmStep: [
    {
      question: 'Confirm step! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListReportPayrollReceiptStep: [
    {
      question: 'Receipt step! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListReportWithFile: [
    {
      question: 'Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListReportWithFileConfirmStep: [
    {
      question: 'Confirm step! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListReportWithFileReceiptStep: [
    {
      question: 'Receipt step! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmploymentPeriod: [
    {
      question: 'Anställningsperiod! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmploymentPeriodReceiptStep: [
    {
      question: 'Kvittens! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEditEmployee: [
    {
      question: 'Personuppgifter! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEditEmployeeReceiptStep: [
    {
      question: 'Kvittens! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmployeePersonInfo: [
    {
      question: 'Personuppgifter! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmployeeEmploymentPeriod: [
    {
      question: 'Anställningsperiod! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListAddEmployeeReceiptStep: [
    {
      question: 'Kvittens! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEditEmploymentPeriod: [
    {
      question: 'Ändra anställningsperiod! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEditEmploymentPeriodReceiptStep: [
    {
      question: 'Kvittens anställningsperiod! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEditParameter: [
    {
      question: 'Parameter! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
  faqListEditParameterReceiptStep: [
    {
      question: 'Kvittens parameter! Curabitur blandit tempus porttitor?',
      answer: 'Nullam quis risus eget urna mollis ornare vel eu leo',
      linkUrl: 'https://www.fora.se',
    },
  ],
};
